import { CardId } from './card-id';
import { CardIndexMapping } from './card-index-mapping';
import { Pile } from './pile';
import { CardDisclosureStatus, PileType } from '../logic-types';

export class Card {
  public readonly index: number;

  public get isFaceUp(): boolean {
    return this._isFaceUp;
  }

  private cardIndexMapping: CardIndexMapping;
  private _isFaceUp: boolean;

  public get cardId(): CardId | undefined {
    return this.cardIndexMapping.cardIdForIndex(this.index);
  }

  constructor(index: number, cardIndexMapping: CardIndexMapping, isFaceUp: boolean) {
    this.index = index;
    this.cardIndexMapping = cardIndexMapping;
    this._isFaceUp = isFaceUp;
  }

  public openCard(): void {
    this._isFaceUp = true;
  }

  public closeCard(): void {
    this._isFaceUp = false;
  }

  public clone(): Card {
    return new Card(this.index, this.cardIndexMapping, this.isFaceUp);
  }

  public setStatusWhenNone(status: CardDisclosureStatus): void {
    this.cardIndexMapping.setStatusWhenNoneForIndex(this.index, status);
  }

  public canMove(originPile: Pile, targetPile: Pile): boolean {
    const cardId = this.cardId;

    if (cardId === undefined) {
      return false;
    }

    if (originPile.id === targetPile.id) {
      return false;
    }

    const targetCard = targetPile.lastCard;

    if (targetPile.type === PileType.Tableau && !targetPile.hasCards && cardId.isKing) {
      return true;
    }
    if (targetPile.type === PileType.Foundation && !targetPile.hasCards && cardId.isAce) {
      return true;
    }
    if (originPile.type === PileType.Deck && targetPile.type === PileType.Waste) {
      return true;
    }

    if (targetCard !== undefined) {
      if (targetCard.cardId === undefined) {
        return false;
      }

      const targetCardId = targetCard.cardId;
      const originPileCardId = originPile.lastCard?.cardId;

      if (targetPile.type === PileType.Tableau && targetCard.isFaceUp && !cardId.isAce) {
        return (
          targetCardId.cardValue - 1 === cardId.cardValue && targetCardId.isRed !== cardId.isRed
        );
      }

      if (
        targetPile.type === PileType.Foundation &&
        originPile.type === PileType.Tableau &&
        originPileCardId?.id === cardId.id
      ) {
        return (
          targetCardId.cardValue + 1 === cardId.cardValue &&
          targetCardId.cardType === cardId.cardType
        );
      }

      if (targetPile.type === PileType.Foundation && originPile.type === PileType.Waste) {
        return (
          targetCardId.cardValue + 1 === cardId.cardValue &&
          targetCardId.cardType === cardId.cardType
        );
      }

      if (targetPile.type === PileType.Foundation && originPile.type === PileType.Deck) {
        return (
          targetCardId.cardValue + 1 === cardId.cardValue &&
          targetCardId.cardType === cardId.cardType
        );
      }
    }

    return false;
  }
}
